import { AuthError } from '@entities/User';

export function mapAuthError(err: unknown): string {
  if (err instanceof AuthError) {
    switch (err.code) {
      case 'REQUIRED_FIELDS':
        return 'auth.errors.requiredFields';
      case 'SHORT_PASSWORD':
        return 'auth.errors.shortPassword';
      case 'INVALID_EMAIL':
        return 'auth.errors.invalidEmail';
      case 'INVALID_NAME':
        return 'auth.errors.invalidName';
      case 'INVALID_DATA':
        return 'auth.errors.invalidData';
      case 'INVALID_CREDENTIALS':
        return 'auth.errors.invalidCredentials';
      case 'EMAIL_EXISTS':
        return 'auth.errors.emailExists';
      case 'RATE_LIMITED':
        return 'auth.errors.rateLimited';
      case 'SERVER':
        return 'auth.errors.server';
      case 'NETWORK':
        return 'auth.errors.network';
    }
  }
  return 'auth.errors.invalidCredentials';
}

/** Ошибка сервера про конкретное поле — показываем под ним, а не плашкой над кнопкой (2026-10-27). */
export function authErrorField(err: unknown): 'name' | 'email' | 'password' | null {
  if (!(err instanceof AuthError)) return null;
  if (err.code === 'INVALID_NAME') return 'name';
  if (err.code === 'INVALID_EMAIL') return 'email';
  if (err.code === 'SHORT_PASSWORD') return 'password';
  return null;
}
